import { Grid } from '@approvalmax/ui/src/components';
import { hooks } from '@approvalmax/utils';
import { stringify } from 'query-string';
import { memo, useCallback, useMemo } from 'react';

import { TransactionsFilter } from '../TransactionsFilter/TransactionsFilter';
import { type FilterValues } from '../TransactionsFilter/TransactionsFilter.types';
import { TransactionsList } from '../TransactionsList/TransactionsList';
import { normalizeFilterValues, parseFilterValuesFromQuery } from './TransactionsTab.helpers';

export const TransactionsTab = memo(() => {
    const [filterQuery, setFilterQuery] = hooks.useQueryParam('filter');
    const [, setPageQuery] = hooks.useQueryParam('page');

    const handleFilterSubmit = useCallback(
        (filter: FilterValues) => {
            setFilterQuery(stringify(normalizeFilterValues(filter)));
            setPageQuery('0');
        },
        [setFilterQuery, setPageQuery]
    );

    const filterValue = useMemo(() => {
        return parseFilterValuesFromQuery(filterQuery);
    }, [filterQuery]);

    return (
        <Grid rowGap={16}>
            <TransactionsFilter filter={filterValue} onSubmit={handleFilterSubmit} />

            <TransactionsList filter={filterValue} />
        </Grid>
    );
});

TransactionsTab.displayName = 'TransactionsTab';
